import { Menu as UIMenu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/16/solid';
type MenuProps = {
  buttonText: string | React.ReactNode;
  items: React.ReactNode[];
  dividersIndex?: number[];
};

export const Menu = ({ buttonText, items, dividersIndex }: MenuProps) => {
  return (
    <UIMenu>
      <MenuButton className="inline-flex items-center gap-2 rounded-md bg-cyan-800 py-1.5 px-3 text-sm/6 font-semibold text-white focus:outline-none data-[hover]:bg-cyan-700 data-[open]:bg-cyan-700 data-[focus]:outline-1 data-[focus]:outline-white">
        {buttonText}
        <ChevronDownIcon className="size-4 fill-white/60" />
      </MenuButton>

      <MenuItems
        transition
        anchor="bottom end"
        className="z-50 mt-2 minW-52 bg-white shadow-lg origin-top-right rounded-lg border p-1 text-sm/6 text-black transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0">
        {items.map((item, index) => (
          <>
            {dividersIndex?.includes(index) && <div className="my-1 h-px bg-stone-300" />}
            <MenuItem key={index}>{item}</MenuItem>
          </>
        ))}
      </MenuItems>
    </UIMenu>
  );
};
